export const GRAPHQL_ENDPOINT = process.env.VUE_APP_ROOT_API;